module.exports = {"Creating_archive":"Creating archive","Export_completed":"Export completed","Export_failed":"Export failed","Export_queued":"Export queued","Fetching_attachments":"Fetching attachments","Fetching_board_data":"Fetching board data","Preparing_download":"Preparing download","Preparing_to_export":"Preparing to export"}


//////////////////
// WEBPACK FOOTER
// ./resources/strings/exports/en.json
// module id = llIV
// module chunks = 26 27 28